"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.headerHeight = exports.scrollerWidth = void 0;
var core_1 = require("@material-ui/core");
var defaultTheme_1 = require("../../youwell-common/styles/defaultTheme");
var customerPalette = __assign({}, defaultTheme_1.defaultPalette);
exports.scrollerWidth = 16;
exports.headerHeight = 50;
var generateTheme = function (options, darkMode) {
    var _a;
    var paletteFromOptions = (_a = options === null || options === void 0 ? void 0 : options.palette) === null || _a === void 0 ? void 0 : _a.split(';').reduce(function (prev, curr) {
        var _a;
        var currKeyVal = curr === null || curr === void 0 ? void 0 : curr.split(':');
        if ((currKeyVal === null || currKeyVal === void 0 ? void 0 : currKeyVal.length) !== 2) {
            return prev;
        }
        return __assign(__assign({}, prev), (_a = {}, _a[currKeyVal[0]] = currKeyVal[1], _a));
    }, {});
    var palette = __assign(__assign({}, customerPalette), paletteFromOptions);
    var customerThemeProperties = {
        colors: palette,
        shadows: __assign({}, (0, defaultTheme_1.getDefaultShadows)(palette)),
        borders: __assign({}, (0, defaultTheme_1.getDefaultBorders)(palette)),
        shapes: {
            borderRadius: 10,
            borderRadiusRounder: 20,
            borderRadiusFlatter: 5,
        },
    };
    var themeOptions = {
        palette: {
            type: darkMode ? 'light' : 'light',
            primary: {
                main: palette.primary,
            },
            secondary: {
                main: palette.secondary,
            },
            error: {
                main: palette.red,
            },
            background: {
                default: palette.defaultBackground,
                paper: palette.white,
            },
            text: {
                primary: palette.black,
                secondary: palette.grayMiddle,
            },
        },
        youwell: customerThemeProperties,
        shape: {
            borderRadius: customerThemeProperties.shapes.borderRadius,
        },
        typography: {
            fontSize: 16,
        },
        overrides: {
            MuiButton: {
                root: {
                    borderRadius: 20,
                },
                outlinedPrimary: {
                    borderWidth: 2,
                    color: palette.black,
                    '&:hover': {
                        borderWidth: 2,
                    },
                },
                containedPrimary: {
                    borderWidth: 2,
                    color: palette.white,
                    '&:hover': {
                        borderWidth: 2,
                    },
                },
                outlinedSecondary: {
                    borderWidth: 2,
                    color: palette.black,
                    '&:hover': {
                        borderWidth: 2,
                    },
                },
                containedSecondary: {
                    borderWidth: 2,
                    color: palette.white,
                    '&:hover': {
                        borderWidth: 2,
                    },
                },
            },
            MuiDrawer: {
                paper: {
                    maxWidth: '100%',
                },
            },
            MuiTypography: {
                body1: {
                    fontSize: '1.1875rem',
                    lineHeight: '1.473685em',
                },
                subtitle1: {
                    lineHeight: '1.5em',
                },
                subtitle2: {
                    fontSize: '1.1875rem',
                },
            },
        },
    };
    return (0, core_1.createTheme)(themeOptions);
};
exports.default = generateTheme;
